import React, { useState } from 'react';

interface ReportTagButtonProps {
  matchId: string;
  reviewedPlayerId: string;
  tagText: string;
  onAutoHidden?: () => void;
}

type State = 'idle' | 'pending' | 'reported' | 'error' | 'needs-login';

export default function ReportTagButton({
  matchId,
  reviewedPlayerId,
  tagText,
  onAutoHidden,
}: ReportTagButtonProps) {
  const [state, setState] = useState<State>('idle');

  async function handleClick() {
    if (state === 'pending' || state === 'reported') return;

    const token = localStorage.getItem('token');
    if (!token) {
      setState('needs-login');
      setTimeout(() => setState('idle'), 3000);
      return;
    }

    setState('pending');
    try {
      const res = await fetch(`/api/recap/${matchId}/report-tag`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ reviewedPlayerId, tagText }),
      });

      if (!res.ok) {
        setState('error');
        setTimeout(() => setState('idle'), 3000);
        return;
      }

      const data = await res.json();
      setState('reported');
      if (data.autoHidden && onAutoHidden) {
        onAutoHidden();
      }
    } catch {
      setState('error');
      setTimeout(() => setState('idle'), 3000);
    }
  }

  const labels: Record<State, string> = {
    idle: 'Reportar',
    pending: 'Reportando…',
    reported: 'Reportado',
    error: 'Error',
    'needs-login': 'Login requerido',
  };

  return (
    <button
      onClick={handleClick}
      disabled={state === 'pending' || state === 'reported'}
      title={labels[state]}
      aria-label={`Reportar tag ${tagText}`}
      style={{
        background: 'transparent',
        border: 'none',
        padding: '2px 4px',
        marginLeft: 4,
        cursor: state === 'pending' || state === 'reported' ? 'default' : 'pointer',
        opacity: state === 'reported' ? 0.4 : 0.6,
        fontSize: 11,
      }}
    >
      🚩
    </button>
  );
}
